export const DISCOUNT_CODE_TYPE_MULTIPLE_TIMES = "multiple";
export const DISCOUNT_CODE_TYPE_ONCE = "once";
export const DISCOUNT_CODE_TYPE_FIRST_ORDER = "first_order";
